'use client';

import { useEffect } from 'react';
import { logError } from '@/core/lib/errorHandler';

export default function Error({
	error,
	reset,
}) {
	useEffect(() => {
		logError(error, 'Route Error Boundary');
	}, [error]);

	return (
		<div style={{
			padding: '100px 20px',
			textAlign: 'center',
			minHeight: '50vh',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
		}}>
			<h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>
				Something went wrong!
			</h2>
			<p style={{ fontSize: '1.1rem', marginBottom: '30px', color: '#666' }}>
				{error?.message || 'An unexpected error occurred'}
			</p>
			<button
				onClick={reset}
				style={{
					padding: '12px 24px',
					background: '#ED2024',
					color: 'white',
					border: 'none',
					borderRadius: '4px',
					cursor: 'pointer',
					fontSize: '1rem',
				}}
			>
				Try again
			</button>
		</div>
	);
}
